import React from 'react';
import { Layout } from '../components/layout';
import { LocalizeProvider } from '../components/localize-context';
import { VisitorProvider } from '../components/visitor-context';
import { LocationContext } from '../components/location-context';
import '../style/globals.scss';

const LayoutContainer = ({ children, pageContext, location }) => {
  return (
    <LocalizeProvider value={pageContext.lang || 'en-us'}>
      <VisitorProvider>
        <LocationContext.Provider value={location}>
          <Layout>{children}</Layout>
        </LocationContext.Provider>
      </VisitorProvider>
    </LocalizeProvider>
  );
};

export default LayoutContainer;
